import {
  QuickNoteCreate,
  QuickNoteSummary,
  QuickNoteUpdate,
} from "@/types/quick-note";

import { requestData } from "@/api/api-config";

export async function createQuickNote(
  quickNote: QuickNoteCreate,
): Promise<QuickNoteSummary | null> {
  return await requestData<QuickNoteSummary>(
    "user/patient/quick-note/create",
    "post",
    {
      json: quickNote,
    },
  );
}

export async function listQuickNotes(
  patientId: string,
  controller?: AbortController,
): Promise<QuickNoteSummary[] | null> {
  return await requestData<QuickNoteSummary[]>(
    `user/patient/quick-note/list/${patientId}`,
    "get",
    {
      signal: controller?.signal,
    },
  );
}

export async function getQuickNote(
  noteId: string,
): Promise<QuickNoteSummary | null> {
  return await requestData<QuickNoteSummary>(
    `user/patient/quick-note/${noteId}`,
    "get",
  );
}

export async function updateQuickNote(
  noteId: string,
  quickNote: QuickNoteUpdate,
): Promise<QuickNoteSummary | null> {
  return await requestData<QuickNoteSummary>(
    `user/patient/quick-note/update/${noteId}`,
    "put",
    {
      json: quickNote,
    },
  );
}

export async function deleteQuickNote(id: string): Promise<boolean> {
  const result = await requestData<boolean>(
    `user/patient/quick-note/${id}`,
    "delete",
  );
  return result || false;
}

export async function togglePinQuickNote(
  noteId: string,
): Promise<QuickNoteSummary | null> {
  return await requestData<QuickNoteSummary>(
    `user/patient/quick-note/${noteId}/pin`,
    "put",
  );
}
